module.exports = __webpack_public_path__ + "static/media/office_1.9526c4a8.svg";